export enum RampDirection {
  BUY = "BUY",
  SELL = "SELL"
}
